import { useApiClient } from '../../../stores/ApiClientStore.js';
import { useHelpSpokeStore } from '../../../stores/index.js';
import { useMutation } from '../../../node_modules/@tanstack/react-query/build/modern/useMutation.js';

const useResendEmailConfirmation=()=>{const{ssClient}=useApiClient();const{currentOrder}=useHelpSpokeStore();const resendEmailConfirmation=async()=>{const url=`/care/RESEND_CONFIRMATION_EMAIL?orderNumber=${currentOrder==null?void 0:currentOrder.orderNumber}`;const response=await ssClient.post(url,{});return response.data.toEmail||null};return useMutation({mutationKey:["resendEmailConfirmation"],mutationFn:resendEmailConfirmation})};

export { useResendEmailConfirmation };
//# sourceMappingURL=useResendEmailConfirmation.js.map
